import axios from 'axios'
import {MasterLoginEndPoint,LoginEndPoint,ClientLoginEndPoint} from '../../../config/AppServerConfig'
axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    return Promise.reject(error.response);
});

class LoginServices {
    static Login( Userinfo){
        if(!Userinfo.isClient)
            return axios.post(LoginEndPoint,{"loginId":Userinfo.loginId,"password":Userinfo.password})
        else
            return axios.post(ClientLoginEndPoint,{"username":Userinfo.loginId,"password":Userinfo.password})

    }
    static MasterLogin( Userinfo) {
        return axios.post(MasterLoginEndPoint,{"loginId":Userinfo.loginId,"password":Userinfo.password})
    }
}

export {LoginServices}
